$(document).ready(function ($) {

    var d = new Date(),
        month = d.getMonth() + 1,
        day = d.getDate(),
        sixYears = (d.getFullYear()),
        twelveYears = (d.getFullYear() - 13);

    /*
	 * Pad a string to a certain length
	 */
    function pad(str, max) {
        str = str.toString();
        return str.length < max ? pad("0" + str, max) : str;
    }

    /**
	 * Show/Hide Parrent address
	 */
    var $otherAdressTrigger = $('.js-diff-address--trigger'),
        $otherAdressWrapper = $('.js-diff-address--wrapper'),
        $otherAdressFields = $otherAdressWrapper.find('input');

    $otherAdressTrigger.change(function () {
        if ($(this).is(':checked')) {
            $otherAdressWrapper.removeClass('u-visually-hidden');
            $otherAdressFields.attr('required', 'required');
        } else {
            $otherAdressWrapper.addClass('u-visually-hidden');
            $otherAdressFields.removeAttr('required');
        }
    }).change();

    /**
     * Yes/no golf player events
     */
    var $doYouGolfRadios = $('#doyougolf-field :radio');
    $doYouGolfRadios.on('change', function (e) {
        switch (this.id) {
            case "doyougolf_ja":
                $('#ngfmember-validation').removeClass('u-visually-hidden');
                // BIJ ERIK NAVRAGEN OF DIT NOG NODIG IS
                //$('#height').removeAttr('required').removeAttr('aria-required');
                //$('#height-required').addClass('hidden');
                break;
            case "doyougolf_nee":
                $('#ngfmember-validation').addClass('u-visually-hidden');
                // BIJ ERIK NAVRAGEN OF DIT NOG NODIG IS
                //$('#height').attr('required', 'required').attr('aria-required', 'true');
                //$('#height-required').removeClass('hidden');
                break;
        }
    });

//    /**
//	 * Validate NGF nr. and barcode
//	 */
//    var $ngfmemberValidation = $('.js-ngfmember-validation'),
//		$ngfnumber = $ngfmemberValidation.find('#ngfnumber'),
//		$barcode = $ngfmemberValidation.find('#barcode'),
//		$errorContainer = $ngfmemberValidation.find('.field-validation-error'),
//		defaultError = $errorContainer.data('valmsg-default');

//    $ngfnumber.rules("add", {
//        number: true,
//        required: function (element) {
//            return $barcode.val() !== "";
//        }
//    });

//    $barcode.rules("add", {
//        number: true,
//        required: function (element) {

//            return $ngfnumber.val() !== "";
//        }
//    });

//    $ngfmemberValidation.find('input').on('change keyup', function () {
//        var ngfnumber = $ngfnumber.val(),
//			barcode = $barcode.val();

//        if (ngfnumber !== '' && barcode !== '') {
//            $.get(window.location.origin + '/isvalidngfmember', { ngfnumber: ngfnumber, barcode: barcode })
//				.done(function (data) {
//				    if (data.Error) {
//				        $ngfmemberValidation.removeClass('valid').addClass('error');
//				        $errorContainer.text(data.Error);
//				    }
//				    if (data.IsValid) {
//				        $ngfmemberValidation.removeClass('error').addClass('valid');
//				        $errorContainer.text('');
//				    } else {
//				        $ngfmemberValidation.removeClass('valid').addClass('error');
//				        $errorContainer.text(defaultError);
//				    }
//				});
//        }
//        if (ngfnumber === '' && barcode === '') {
//            $ngfmemberValidation.find('input').valid();
//            $ngfmemberValidation.removeClass('valid').removeClass('error');
//            $errorContainer.text('');
//        }

//    });

});
